import React from 'react';
import { Link } from 'react-router-dom';
import MysteryPlayerChallenge from './MysteryPlayerChallenge';

const SpectatorSeating = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-indigo-900 to-blue-900">
      {/* Animated Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-purple-500/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-pink-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>

      {/* Header */}
      <div className="relative z-10 bg-black/20 backdrop-blur-md border-b border-white/10 sticky top-0">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-3 sm:py-4">
          <div className="flex items-center justify-between gap-2">
            <Link 
              to="/" 
              className="inline-flex items-center border border-white/30 text-white hover:bg-white/10 hover:border-white/50 font-medium text-sm px-4 py-2 rounded transition-all backdrop-blur-sm"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              <span className="sm:hidden">Back</span>
              <span className="hidden sm:inline">Back to Home</span>
            </Link>
            <div className="flex items-center gap-2">
              <span className="text-2xl">🕵️</span>
              <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-white">
                Mystery Zone
              </h1>
            </div>
            <div className="w-16"></div> {/* Spacer for center alignment */}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-3 sm:px-4 lg:px-8 py-6 sm:py-8">
        {/* Hero Section */}
        <div className="text-center mb-6 sm:mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-yellow-500/20 to-orange-500/20 border border-yellow-500/30 rounded-full text-yellow-300 text-sm font-medium mb-4">
            <span className="animate-pulse">🔥</span>
            Daily Challenge - Play Now!
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white mb-2">
            Can You Identify the
            <span className="block bg-gradient-to-r from-yellow-400 via-pink-400 to-purple-400 text-transparent bg-clip-text">
              Mystery Sports Legend?
            </span>
          </h2>
          <p className="text-white/60 text-sm sm:text-base max-w-lg mx-auto">
            Use clues from Wikipedia to guess the hidden player. 
            The fewer clues you need, the higher your score!
          </p>
        </div>

        {/* Game Card */}
        <div className="bg-white/10 backdrop-blur-lg rounded-3xl border border-white/20 shadow-2xl overflow-hidden">
          <MysteryPlayerChallenge />
        </div>

        {/* Features Section */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-6 sm:mt-8">
          {[
            { icon: '🌍', title: 'Wikipedia Data', desc: 'Real facts' },
            { icon: '📅', title: 'New Daily', desc: 'Fresh player' },
            { icon: '🏆', title: 'Multi-Sport', desc: 'All sports' },
            { icon: '📤', title: 'Share', desc: 'With friends' },
          ].map((feature, index) => (
            <div 
              key={index}
              className="bg-white/5 backdrop-blur border border-white/10 rounded-xl p-3 text-center hover:bg-white/10 transition-colors"
            >
              <span className="text-2xl mb-1 block">{feature.icon}</span>
              <h3 className="text-white font-semibold text-sm">{feature.title}</h3>
              <p className="text-white/50 text-xs">{feature.desc}</p>
            </div>
          ))}
        </div>

        {/* Footer Info */}
        <div className="text-center mt-6 sm:mt-8 text-white/40 text-xs">
          <p>Data powered by Wikipedia API • Share your results on social media!</p>
        </div>
      </div>

      {/* Custom Styles */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
};

export default SpectatorSeating;
